<template>
    <v-ons-page>
        <div class="content">
            <v-ons-list>
                <v-ons-list-header>Latest in Projects</v-ons-list-header>
                <v-ons-list-item v-for="item in recentActivity" :key="item.id" @click="openAttachment(item)">
                    <div class="left qf-project-img">
                        <img v-if="item.project_logo" class="list-item__thumbnail" :src="item.project_logo">
                        <img v-else class="list-item__thumbnail" :src="defaultProjectLogo">
                    </div>
                    <div class="center">
                        {{item.user_names}} added the file {{ item.document_title }}
                        <span class="qf-entry-date">{{item.date | moment}}</span>
                    </div>
                </v-ons-list-item>
            </v-ons-list>
        </div>
        <qf-spinner :showing="loadingData" message="Updating contents..."></qf-spinner>
    </v-ons-page>
</template>

<script>
    import Api from '@/services/api';
    import moment from 'moment';
    import SingleDocument from "../singleViews/SingleDocument";
    import QfSpinner from "../shared/QfSpinner";
    import Login from "../login/Login";

    export default {
        name: 'DashboardProjects',
        components: {QfSpinner},
        data() {
            return {
                title: 'Latest from projects',
                recentActivity: [],
                token: '',
                baseUrl: process.env.VUE_APP_BASE_URL,
                loadingData: false
            }
        },
        mounted() {
            this.refreshList();
        },
        filters: {
            moment: function (date) {
                return moment(date).format('LLLL');
            }
        },
        methods: {
            openAttachment(attachment) {
                let docObject = {
                    id : attachment.document_id,
                    title: attachment.document_title,
                    file_type: attachment.document_file_type
                };
                this.$store.commit('navigator/push', {
                    extends: SingleDocument,
                    data() {
                        return docObject;
                    }
                });
            },
            goToLogin(){
                this.$store.commit('navigator/replace', {
                    extends: Login,
                    data() {
                        return {
                            bounced: true
                        };
                    }
                });
            },
            refreshList() {
                let self = this;
                this.token = this.$getCookie('access_token');
                self.loadingData = true;
                if(this.token){
                    Api().get('/dashboard/projects').then(response => {
                        //console.log(response.data);
                        self.recentActivity = response.data;
                        self.loadingData = false;
                    }).catch(() => {
                        self.loadingData = false;
                        self.goToLogin();
                        //console.log(err);
                        //self.$handleReject()
                    });
                }else{
                    self.loadingData = false;
                    self.goToLogin();
                    //self.$handleReject()
                }

            }
        },
        computed: {
            currentTabBar(){
                return this.$store.state.shared.homeTabIndex;
            },
            defaultProjectLogo(){
                return `https://`+process.env.VUE_APP_VARIANT+`.capecloud.ch/images/placeholder-logo.png`
            }
        },
        watch: {
            $route() {
                this.refreshList();
            },
            currentTabBar(curTab){
                if(curTab === 1){
                    this.refreshList();
                }
            }
        }
    }
</script>

<style scoped>
    .qf-entry-date {
        font-size:0.75em;
    }
    .qf-project-img {align-items: baseline}
    .qf-project-img img{border-radius: 5px}

</style>
